import React from 'react'
import { CarouselProgressDotContainer, FadeInContainer, ProgressFadeInContainer, ContentContainer } from './style'
import { PreviousButton, NextButton } from '../../commons/CarouselArrowButtons'
import CarouselProgressDot from './CarouselProgressDot'
import CarouselSlides from './CarouselSlides'
import CarouselContent from './CarouselContent'
import { LaunchModalContextProvider, useLaunchModalContext } from '../../../../contexts/LaunchModalContext'
import { CarouselSlideShapeProps } from '../..'
interface ariaLabelsProps {
  previous: string
  next: string
}

const SLIDE_DURATION = 3000

const Carousel: React.VFC<{
  ariaLabels: ariaLabelsProps
  slides: CarouselSlideShapeProps[]
  slidesDuration?: number
  dataTaktId: string
}> = ({ ariaLabels, slides, slidesDuration, dataTaktId }) => {
  const slidesLength = slides.length
  const calcSlidesDuration = slidesDuration ?? slides?.[0]?.duration ?? SLIDE_DURATION

  const progressComponents = slides.map((slide, index) => (
    <CarouselProgressDot
      // eslint-disable-next-line react/no-array-index-key
      key={`progress-dot-${index}`}
      ariaLabel={slide.headline}
      progressIndex={index}
    />
  ))

  const slidesImage = slides.map((slide, index) => <CarouselSlides key={slide.caption} image={slide.image} index={index} />)

  const slidesContent = slides.map((slide, index) => <CarouselContent key={slide.caption} caption={slide.caption} headline={slide.headline} link={slide.link} index={index} dataTaktId={dataTaktId} />)

  const Carousel = () => {
    const { activeIndex } = useLaunchModalContext()
    const isFirstSlide = activeIndex === 0
    const isLastSlide = activeIndex === slides.length - 1
    return (
      <>
        <FadeInContainer>
          {!isFirstSlide && <PreviousButton label={ariaLabels.previous} isMobile={true} />}
          {slidesImage}
          {!isLastSlide && <NextButton label={ariaLabels.next} isMobile={true} />}
        </FadeInContainer>
        <ContentContainer>{slidesContent}</ContentContainer>
      </>
    )
  }

  return slidesLength > 1 ? (
    <LaunchModalContextProvider slidesDuration={calcSlidesDuration} slidesLength={slidesLength} isMobile={true} dataTaktId={dataTaktId}>
      <Carousel />
      <ProgressFadeInContainer>
        <CarouselProgressDotContainer>{progressComponents}</CarouselProgressDotContainer>
      </ProgressFadeInContainer>
    </LaunchModalContextProvider>
  ) : (
    <Carousel />
  )
}

export default Carousel
